import { render, staticRenderFns } from "./EditingDFPriority.vue?vue&type=template&id=5abcf4ea&"
import script from "./EditingDFPriority.vue?vue&type=script&lang=js&"
export * from "./EditingDFPriority.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports